/* eslint-disable no-restricted-globals */
import { h, render } from 'preact'

import elements from '@constants/elements'
import onReady from '@utils/onReady'
import renderSharedUI from '@utils/renderSharedUI'
import ArchivePage from '@ui/Archive/ArchivePage'

onReady().then(() => {
    renderSharedUI();

    const archive = document.querySelector(elements.archivePage); 
    const footer = document.querySelector(elements.footer);
    render(<ArchivePage pageType="category" />, archive);
    render(<Footer />, footer);
})